export const SIP_INTERACTION_ALREADY_ANSWERED_ERROR = 'interaction_already_answered';
